import React, { memo } from 'react';
import { PieChart as RechartsPieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { PieChart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Color scheme for charts
const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#F97316'];

const PieChartComponent = memo(({ 
  data, 
  title, 
  loading = false,
  dataKey = 'value',
  labelFormat = ({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`,
  tooltipFormatter = (value) => [value, 'Value'],
  outerRadius = 80,
  showLabel = true,
  className = ''
}) => {
  const { t } = useTranslation();

  return (
    <div className={`card ${className}`}>
      <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4">{title}</h3>
      {loading || !data || data.length === 0 ? (
        <div className="flex items-center justify-center h-[300px]">
          {loading ? (
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-2"></div>
              <p className="text-sm text-gray-500 dark:text-gray-400">{t('common.loading')}</p>
            </div>
          ) : (
            <div className="text-center">
              <PieChart className="h-12 w-12 text-gray-400 dark:text-gray-500 mx-auto mb-2" />
              <p className="text-sm text-gray-500 dark:text-gray-400">{t('dashboard.noDataAvailable')}</p>
            </div>
          )}
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <RechartsPieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={outerRadius}
              fill="#8884d8"
              dataKey={dataKey}
              label={showLabel ? labelFormat : false}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip formatter={tooltipFormatter} />
          </RechartsPieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
});

PieChartComponent.displayName = 'PieChartComponent';

export default PieChartComponent;
